import constants from '../../../containers/widget/constants';
import algorithms from '../../../containers/widget/constants/algorithms';

export const initialState = {
	isFetching: false,
	algorithmType: algorithms.PAIVER,
	recommendedVendors: [],
	source: null,
};

export default function paiverVendorsReducer(
	state = initialState,
	action = {},
) {
	switch (action.type) {
		case constants.CLEAR_RECOMMENDED_VENDORS:
			return {
				...state,
				isFetching: false,
				recommendedVendors: [],
				source: null,
			};
		case constants.FETCH_PAIVER_VENDORS:
			return {
				...state,
				isFetching: true,
				recommendedVendors: [],
			};
		case constants.FETCH_PAIVER_VENDORS_SUCCESS:
			return {
				...state,
				isFetching: false,
				recommendedVendors: action.payload.profiles,
				source: action.payload.source || null,
			};
		case constants.FETCH_PAIVER_VENDORS_ERROR:
			return {
				...state,
				isFetching: false,
				recommendedVendors: [],
				source: null,
				errorMessage: action.error || action.payload.data.errorMessage,
			};
		default:
			return state;
	}
}
